import script from "./MyCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./MyCropper.vue?vue&type=script&setup=true&lang=js"

import "./MyCropper.vue?vue&type=style&index=0&id=c32d1a74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c32d1a74"]])

export default __exports__